import './WelcomeModal.scss';

import { Modal } from 'antd';
import { useEffect, useState } from 'react';

import DocChat1 from '../assets/WelcomeIcons/DocChat1';
import DocChat2 from '../assets/WelcomeIcons/DocChat2';
import DocChat3 from '../assets/WelcomeIcons/DocChat3';
import DocCompare1 from '../assets/WelcomeIcons/DocCompare1';
import DocCompare2 from '../assets/WelcomeIcons/DocCompare2';
import DocCompare3 from '../assets/WelcomeIcons/DocCompare3';
import DocCompare4 from '../assets/WelcomeIcons/DocCompare4';

const welcomeModalData = {
  DocChat: {
    heading: 'Mike DocChat',
    subHeading: 'Your AI powered document analysis tool',
    ctaLabel: 'Start Using Mike DocChat',
    points: [
      {
        id: 1,
        icon: DocChat1,
        title: 'Upload multiple documents',
        description: 'You can upload upto 50 documents and analyse them',
      },
      {
        id: 2,
        icon: DocChat2,
        title: 'Ask contextual questions',
        description:
          'You can ask any legally contextual questions on your documents and get answers to them in seconds',
      },
      {
        id: 3,
        icon: DocChat3,
        title: 'Document agnostic',
        description:
          'You can ask questions across contracts, litigations and any other legal document',
      },
      {
        id: 4,
        icon: DocCompare4,
        title: 'Share the analysis',
        description: 'You can export the entire analysis in pdf or word and share internally',
      },
    ],
  },

  DocCompare: {
    heading: 'Mike DocCompare',
    subHeading: 'Your AI powered contextual comparison tool',
    ctaLabel: 'Start Using DocCompare',
    points: [
      {
        id: 1,
        icon: DocCompare1,
        title: 'Upload multiple documents',
        description: 'You can upload upto 50 documents and compare them',
      },
      {
        id: 2,
        icon: DocCompare2,
        title: 'Identify deviations',
        description:
          'The system will contextually compare and show differences between the documents',
      },
      {
        id: 3,
        icon: DocCompare3,
        title: 'Internal contradictions',
        description:
          'The system will also identify if there are contradictions taking place within a document',
      },
      {
        id: 4,
        icon: DocCompare4,
        title: 'Share the analysis',
        description: 'You can export the entire analysis in excel and share internally',
      },
    ],
  },
};

const modalRender = (node) => <div className='welcome-modal-scroll'>{node}</div>;

const WelcomeModal = ({ open, variant, onCtaClick }) => {
  const content = welcomeModalData[variant];

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      const isBrowser = typeof window !== 'undefined';
      if (isBrowser) {
        setIsMobile(window.innerWidth < 480);
      }
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  if (!content) return null;

  return (
    <Modal
      className='welcome-modal-no-close'
      classNames={{
        wrapper: 'welcome-modal-wrapper',
      }}
      open={open}
      footer={null}
      centered
      width={isMobile ? '95vw' : 870}
      title={null}
      closeIcon={null}
      maskClosable={false}
      modalRender={modalRender}
    >
      <div className='welcome-modal-root'>
        <div className='welcome-modal-header'>
          <h2 className='welcome-modal-title'>
            {'Welcome to '}
            <span>{content.heading}</span>
          </h2>
          <p className='welcome-modal-subtitle'>{content.subHeading}</p>
        </div>

        <div className='welcome-modal-layout'>
          <div className='welcome-modal-points-grid'>
            {content.points.map((point) => (
              <div key={point.id} className='welcome-modal-point'>
                <div className='welcome-modal-icon-wrapper'>
                  {typeof point.icon === 'string' ? (
                    <img src={point.icon} alt={point.title} />
                  ) : (
                    <point.icon />
                  )}
                </div>
                <div>
                  <div className='welcome-modal-point-title'>{point.title}</div>
                  <p className='welcome-modal-point-text'>{point.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className='welcome-modal-cta-wrapper'>
          <button onClick={onCtaClick} className='welcome-modal-cta-btn'>
            {content.ctaLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default WelcomeModal;
